import { cn } from "@newxsystems/shared";
import { AbyssCommonContent } from "../../../../modules/content/components/AbyssCommonContent/AbyssCommonContent";
import { AbyssRichText } from "../../../../modules/content/components/AbyssRichText/AbyssRichText";
import { AbyssSection } from "../../../../modules/content/components/AbyssSection/AbyssSection";
import type { IStatsBlockProps } from "./StatsBlock.props";

const columns = {
  1: "grid-cols-1",
  2: "grid-cols-1 sm:grid-cols-2",
  3: "grid-cols-1 sm:grid-cols-2 md:grid-cols-3",
  4: "grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4",
} as const;

export const StatsBlock = ({
  alignment,
  anchorId,
  buttons,
  columnCount,
  description,
  eyebrow,
  heading,
  items,
  parentClass,
  spacing,
}: IStatsBlockProps) => {
  if (!items?.length) return null;

  return (
    <AbyssSection className={parentClass} id={anchorId} spacing={spacing}>
      <div className="flex flex-col gap-10 md:gap-14">
        <AbyssCommonContent
          alignment={alignment}
          buttons={buttons}
          description={description}
          eyebrow={eyebrow}
          heading={heading}
        />
        <div className={cn("grid border-t border-iron", columns[columnCount || 3])}>
          {items.map((item, index) => (
            <article
              className="border-b border-iron bg-obsidian/20 px-5 py-7 sm:border-r sm:last:border-r-0"
              key={index}
            >
              <p className="font-abyss-display text-5xl font-medium leading-none tracking-[-0.03em] text-foreground md:text-6xl">
                {item.value}
              </p>
              <h3 className="mt-5 font-abyss-mono text-sm font-medium text-foreground">
                {item.label}
              </h3>
              {item.description ? (
                <AbyssRichText
                  className="mt-3 max-w-[32ch] text-base text-fog md:text-lg"
                  content={item.description}
                />
              ) : null}
            </article>
          ))}
        </div>
      </div>
    </AbyssSection>
  );
};

StatsBlock.displayName = "Block::StatsBlock";
